import {Model} from "./Model";
import {IApiContestant, IApiContestantRank} from "../typings/apiResponse";
import {IContestant} from "../typings/IContestant";
import {Team} from "./Team";
import {User} from "./User";
import * as angular from "angular";
import {ContestantInfo} from "./ContestantInfo";

export class Contestant extends ContestantInfo {
    constructor(protected apiData: IApiContestant) {
        super(apiData);
    }

    public getContestant(): IContestant {
        if (angular.isDefined(this.apiData.team)) {
            return new Team(this.apiData.team);
        } else {
            return new User(this.apiData.user);
        }
    }
}